/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ServiceMilestoneDTO } from '../../entities/service/MilestoneDTO'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { domainDriverCompanyTargetMilestoneProgressStatusSchema } from '../domain/driverCompanyTargetMilestoneProgressStatusSchema'
import { z } from 'zod'

export const serviceMilestoneDTOSchema = z.object({
  position: z.number().int(),
  reward_amount: z.number().optional(),
  status: z.lazy(() => domainDriverCompanyTargetMilestoneProgressStatusSchema),
  target_orders_count: z.number().int(),
}) as unknown as ToZod<ServiceMilestoneDTO>